/**
 * **Seekda**
 *
 * @exports partnership_140
 * @category partnerships
 */
function factory({ window, document, thn }) {

  const partnership = {};

  /**
    * @memberOf module:partnership_140
    */
  partnership.getId = function getId() {
    return '140';
  };

  /**
    * @memberOf module:partnership_140
    */
  partnership.check = function check() {
    const pathNameRegex = /buchen|booking|buchung|bookings|reservation|restavracije|book-online|online-buchen/;
    const hostNameRegex = /booking|buchung/;
    return !!window.location.pathname.match(pathNameRegex) || !!window.location.hostname.match(hostNameRegex);
  };

  /**
    * @memberOf module:partnership_140
    */
  partnership.getSiteId = function getSiteId() {
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;
    const isLieblingsplatzBrand = hostname.includes('lieblingsplatz');
    const hotelIdFromDl = thn.objectGet(window.dataLayer, 'propertyCode', { first: false });
    const hotelIdFromUrl = isLieblingsplatzBrand ? pathname.split('/')[1] : hostname.split('.')[1];
    const result = {
      externalId: hotelIdFromDl || hotelIdFromUrl || '',
    };

    return result;
  };

  return partnership;
}

export { factory };
